import React from "react";
import TempoModal from "./Core/TempoModal";
import { Button } from "./ui/button";

interface DisconnectRepoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDisconnecting: boolean;
}

const DisconnectRepoModal: React.FC<DisconnectRepoModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isDisconnecting,
}) => {
  //   const [dontWarnAgain, setDontWarnAgain] = useState(false);

  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    // Logic for "Don't warn me again" can be added here later
    // For now, it just calls the onConfirm prop
    onConfirm();
    onClose();
  };

  return (
    <TempoModal
      header="Disconnect Repo"
      onClose={onClose}
      className="git-disconnect-modal min-w-[400px]" // You might want to adjust styling
    >
      <div className="w-full flex flex-col gap-y-4">
        <p className="text-sm text-text-primary">
          Are you sure you want to disconnect this repo? You can create a new
          one, but you won't be able to reconnect it.
        </p>

        {/* TODO add in checkbox with persistence
        <div className="flex items-center space-x-2">
          <Checkbox
            id="dont-warn-again"
            checked={dontWarnAgain}
            onCheckedChange={(checked) => setDontWarnAgain(checked === true)}
          />
          <label
            htmlFor="dont-warn-again"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            Don't warn me again
          </label>
        </div> */}
        <div className="flex justify-end w-full gap-2 mt-4">
          <Button
            variant="outline"
            className="bg-background-secondary text-xs px-3 py-0 h-7 min-h-0 leading-none"
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            variant="destructive"
            className="text-xs px-3 py-0 h-7 min-h-0 leading-none"
            onClick={handleConfirm}
            disabled={isDisconnecting}
          >
            {isDisconnecting ? "Disconnecting..." : "Disconnect"}
          </Button>
        </div>
      </div>
    </TempoModal>
  );
};

export default DisconnectRepoModal;
